import type { Components, Theme } from '@mui/material/styles';

import { colors } from '../palette/colors';

export const alertComponents: Components<Theme> = {
    MuiAlert: {
        styleOverrides: {
            standardInfo: ({ theme }) => ({
                color:
                    theme.palette.mode === 'dark'
                        ? colors.status.info.darkForeground
                        : colors.status.info.foreground,

                backgroundColor:
                    theme.palette.mode === 'dark'
                        ? colors.status.info.darkSubtle
                        : colors.status.info.subtle,

                borderColor:
                    theme.palette.mode === 'dark'
                        ? colors.status.info.darkMuted
                        : colors.status.info.muted,

                '& .MuiSvgIcon-root': {
                    color:
                        theme.palette.mode === 'dark'
                            ? colors.status.info.darkForeground
                            : colors.status.info.foreground,
                },
            }),

            standardSuccess: ({ theme }) => ({
                color:
                    theme.palette.mode === 'dark'
                        ? colors.status.success.darkForeground
                        : colors.status.success.foreground,

                backgroundColor:
                    theme.palette.mode === 'dark'
                        ? colors.status.success.darkSubtle
                        : colors.status.success.subtle,

                borderColor:
                    theme.palette.mode === 'dark'
                        ? colors.status.success.darkMuted
                        : colors.status.success.muted,

                '& .MuiSvgIcon-root': {
                    color:
                        theme.palette.mode === 'dark'
                            ? colors.status.success.darkForeground
                            : colors.status.success.foreground,
                },
            }),

            standardError: ({ theme }) => ({
                color:
                    theme.palette.mode === 'dark'
                        ? colors.status.error.darkForeground
                        : colors.status.error.foreground,

                backgroundColor:
                    theme.palette.mode === 'dark'
                        ? colors.status.error.darkSubtle
                        : colors.status.error.subtle,

                borderColor:
                    theme.palette.mode === 'dark'
                        ? colors.status.error.darkMuted
                        : colors.status.error.muted,

                '& .MuiSvgIcon-root': {
                    color:
                        theme.palette.mode === 'dark'
                            ? colors.status.error.darkForeground
                            : colors.status.error.foreground,
                },
            }),

            standardWarning: ({ theme }) => ({
                color:
                    theme.palette.mode === 'dark'
                        ? colors.status.warning.darkForeground
                        : colors.status.warning.foreground,

                backgroundColor:
                    theme.palette.mode === 'dark'
                        ? colors.status.warning.darkSubtle
                        : colors.status.warning.subtle,

                borderColor:
                    theme.palette.mode === 'dark'
                        ? colors.status.warning.darkMuted
                        : colors.status.warning.muted,

                '& .MuiSvgIcon-root': {
                    color:
                        theme.palette.mode === 'dark'
                            ? colors.status.warning.darkForeground
                            : colors.status.warning.foreground,
                },
            }),

            outlinedInfo: ({ theme }) => ({
                color:
                    theme.palette.mode === 'dark'
                        ? colors.status.info.darkForeground
                        : colors.status.info.foreground,

                borderColor:
                    theme.palette.mode === 'dark'
                        ? colors.status.info.darkMuted
                        : colors.status.info.muted,

                '& .MuiSvgIcon-root': {
                    color:
                        theme.palette.mode === 'dark'
                            ? colors.status.info.darkForeground
                            : colors.status.info.foreground,
                },
            }),

            outlinedSuccess: ({ theme }) => ({
                color:
                    theme.palette.mode === 'dark'
                        ? colors.status.success.darkForeground
                        : colors.status.success.foreground,

                borderColor:
                    theme.palette.mode === 'dark'
                        ? colors.status.success.darkMuted
                        : colors.status.success.muted,

                '& .MuiSvgIcon-root': {
                    color:
                        theme.palette.mode === 'dark'
                            ? colors.status.success.darkForeground
                            : colors.status.success.foreground,
                },
            }),

            outlinedError: ({ theme }) => ({
                color:
                    theme.palette.mode === 'dark'
                        ? colors.status.error.darkForeground
                        : colors.status.error.foreground,

                borderColor:
                    theme.palette.mode === 'dark'
                        ? colors.status.error.darkMuted
                        : colors.status.error.muted,

                '& .MuiSvgIcon-root': {
                    color:
                        theme.palette.mode === 'dark'
                            ? colors.status.error.darkForeground
                            : colors.status.error.foreground,
                },
            }),

            outlinedWarning: ({ theme }) => ({
                color:
                    theme.palette.mode === 'dark'
                        ? colors.status.warning.darkForeground
                        : colors.status.warning.foreground,

                borderColor:
                    theme.palette.mode === 'dark'
                        ? colors.status.warning.darkMuted
                        : colors.status.warning.muted,

                '& .MuiSvgIcon-root': {
                    color:
                        theme.palette.mode === 'dark'
                            ? colors.status.warning.darkForeground
                            : colors.status.warning.foreground,
                },
            }),
        },
    },
};
